import { formatDuration, intervalToDuration } from "date-fns";

export function formatSecondsToHHMMSS(seconds) {
  if (!seconds) return "00:00:00";

  const duration = intervalToDuration({ start: 0, end: parseInt(seconds) * 1000 });

  return formatDuration(duration, { format: ["hours", "minutes", "seconds"], zero: true })
    .replace(/(\d+) hours?/, (_, h) => h.padStart(2, "0"))
    .replace(/(\d+) minutes?/, (_, m) => m.padStart(2, "0"))
    .replace(/(\d+) seconds?/, (_, s) => s.padStart(2, "0"))
    .replace(/\s/g, ":");
}
